import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props} from './types';

import * as S from './styles';

export const RefundsListItemJSX: FC<Props> = ({
  amount,
  by,
  date,
  description,
  isRetryAvailable,
  onRetryButtonClick,
  status,
  statusVariant,
  tax,
  ...rest
}) => {
  const {t} = useI18n();

  return (
    <S.Container {...rest}>
      <S.ContentWrapper>
        <S.LeftSide>
          <S.IconContainer>
            <S.Icon type={by} />
          </S.IconContainer>
          <S.DateContainer>
            <S.Date>{date}</S.Date>
            <S.Status $statusVariant={statusVariant}>{status}</S.Status>
          </S.DateContainer>
        </S.LeftSide>
        <S.RightSide>
          <S.Amount $statusVariant={statusVariant}>{amount}</S.Amount>
          {tax ? <S.Tax>{tax}</S.Tax> : null}
        </S.RightSide>
      </S.ContentWrapper>
      {description ? (
        <S.DescriptionContainer>
          <S.Description>{description}</S.Description>
        </S.DescriptionContainer>
      ) : null}
      {isRetryAvailable ? (
        <S.RetryButton onClick={onRetryButtonClick}>
          <S.RetryButtonText>{t('shared:try_again')}</S.RetryButtonText>
        </S.RetryButton>
      ) : null}
    </S.Container>
  );
};
